import React from "react";

const SectionCard = ({
  title,
  icon,
  children,
  maxWidth = "max-w-[1150px]",
  maxHeight = "max-h-[536px]",
}) => (
  <div
    className={`rounded-2xl border bg-[#FFFFFF] border-[#E4E4E780] p-6 ${maxWidth} ${maxHeight} shadow-[0_4px_6px_-4px_rgba(0,0,0,0.08),0_10px_15px_-3px_rgba(0,0,0,0.08)]`} // Added overflow-hidden
  >
    <div className="mb-5 flex items-center gap-2">
      <span className="inline-flex h-9 w-9 items-center justify-center">
        {icon}
      </span>
      <div className="text-base font-semibold text-[#17171C]">{title}</div>
    </div>
    {children}
  </div>
);

export default SectionCard;
